module.exports = __webpack_public_path__ + "img/charging-service-management.dab06d82.png";